// extracted by mini-css-extract-plugin
export default {"page_gap":"MainLayout_page_gap__XU6PN","sticky_button":"MainLayout_sticky_button__rvC2e"};